import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useGetGroup } from 'legacy/groups/hooks';

import PageSkeleton from 'components/PageSkeleton';
import ScreenTopBar, { TopBarVariants } from 'legacy/components/ScreenTopBar';
import CenteredContainer from 'components/CenteredContainer';
import OrganizationTitleForm from '../OrganizationTitleForm';
import { useCreateOrganizationTitle } from 'api/queries/organizations/titles';

const OrganizationTitleCreate = () => {
  const { t } = useTranslation(['organizations']);
  const router = useRouter();
  const organizationId = router.query.organizationId as string;
  const { data: organization, isLoading: isLoadingOrganization } = useGetGroup({
    groupId: organizationId
  });

  const createOrganizationTitleMutation = useCreateOrganizationTitle();

  const goBack = () => {
    router.push(`/organizations/${organization.id}/members/titles`);
  };

  if (isLoadingOrganization || !organization) {
    return <PageSkeleton />;
  }

  return (
    <>
      <ScreenTopBar
        onBack={
          router.pathname !== '/organizations/[organizationId]/dashboard'
            ? goBack
            : undefined
        }
        title={t('titleManagement.createTitle')}
        variant={TopBarVariants.Big}
        wideContent
      />
      <div className="-mt-[41px] md:mt-[61px] pt-7">
        <CenteredContainer>
          <OrganizationTitleForm
            isLoading={createOrganizationTitleMutation.isLoading}
            onSubmit={(values) => {
              createOrganizationTitleMutation.mutate(
                {
                  organizationId,
                  title: {
                    name: values.name,
                    description: values.description,
                    isVisible: values.isVisible
                  }
                },
                {
                  onSuccess: () => {
                    goBack();
                  }
                }
              );
            }}
          />
        </CenteredContainer>
      </div>
    </>
  );
};

export default OrganizationTitleCreate;
